import { z } from "zod";
import { AgendaItemSchema } from "../../models/agendaItem.schema";

export const PrivateAgendaItemControllerResponseSchema = {
  mailItemApproval: z.boolean(),

  listAgendaItems: AgendaItemSchema.array(),

  getAgendaItem: AgendaItemSchema.nullable(),

  getAgendaItemVersion: AgendaItemSchema.nullable(),

  createAgendaItem: AgendaItemSchema,

  updateAgendaItem: AgendaItemSchema,

  deleteAgendaItem: z.void(),
};
